module.exports = __webpack_public_path__ + "img/8567.49470f2d.jpg";